export const NEON_RELAY_ROUTES = [
  {
    name: 'Midtown Spark',
    durationMs: 33000,
    spawnRateMs: 900,
    speed: 142,
    targetPackets: 9,
    blockerBias: 0.34,
    themeId: 'midtown',
  },
  {
    name: 'Signal Market',
    durationMs: 36000,
    spawnRateMs: 760,
    speed: 168,
    targetPackets: 14,
    blockerBias: 0.44,
    themeId: 'market',
  },
  {
    name: 'Glassway Rush',
    durationMs: 38000,
    spawnRateMs: 660,
    speed: 194,
    targetPackets: 18,
    blockerBias: 0.52,
    themeId: 'glassway',
  },
  {
    name: 'Last Uplink',
    durationMs: 43000,
    spawnRateMs: 600,
    speed: 214,
    targetPackets: 23,
    blockerBias: 0.56,
    themeId: 'uplink',
  },
];

export const neonRelayDefinition = {
  id: 'neon-relay',
  name: 'Neon Relay',
  summary: 'Switch lanes, chain packets, dodge blockers, and keep the city timer alive.',
  instructions: 'Switch lanes with arrows, A/D, or touch joystick. Enter or Space confirms.',
  storageNamespace: 'neon-relay',
  themeClass: 'theme-neon-relay',
  routes: NEON_RELAY_ROUTES,
};
